import type { UserClaims } from './permissions'

const TOKEN_KEY = 'access_token'

export function saveToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token)
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY)
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

/** Parse claims from a JWT payload (no verification — server verifies). */
export function parseClaims(token: string): UserClaims | null {
  try {
    const [, payload] = token.split('.')
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
    if (!decoded.sub || !decoded.role) return null
    return {
      user_id: decoded.sub,
      email: decoded.email ?? '',
      role: decoded.role,
      permissions: decoded.permissions ?? [],
    }
  } catch {
    return null
  }
}

export function isTokenExpired(token: string): boolean {
  try {
    const [, payload] = token.split('.')
    const { exp } = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
    return exp * 1000 < Date.now()
  } catch {
    return true
  }
}
